import { z } from 'zod';
import { InventoryAdjustReason } from '../../constants/inventory-adjust-reason.js';
import { requiredClientGeneratedUuidString, requiredUuidString } from '../zod-helpers/index.js';
import { INVENTORY_ADJUST_CONSTRAINTS as LIMITS } from './constraints.js';
const quantity = (min) => {
    const base = z.number({ error: `${LIMITS.quantity.label} is required.` });
    return (min === 'positive'
        ? base.positive(`${LIMITS.quantity.label} must be greater than zero.`)
        : base.min(0, `${LIMITS.quantity.label} cannot be negative.`)).max(LIMITS.quantity.max, `${LIMITS.quantity.label} must be 1,000,000,000 or less.`);
};
/** Field schemas every reconciliation input shares, so the four mutations bound them identically. */
export const ADJUST_FIELDS = {
    requestId: () => requiredClientGeneratedUuidString('Request id is required.', 'Invalid request id.'),
    id: (label) => requiredUuidString(`${label} is required.`, `Invalid ${label.toLowerCase()} selection.`),
    quantity: () => quantity('positive'),
    countedQuantity: () => quantity('nonNegative'),
    unitCost: () => z
        .number({ error: `${LIMITS.unitCost.label} is required.` })
        .min(0, `${LIMITS.unitCost.label} cannot be negative.`)
        .max(LIMITS.unitCost.max, `${LIMITS.unitCost.label} must be 1,000,000,000 or less.`),
    reasonId: () => z.enum(InventoryAdjustReason, 'Invalid reason.'),
    note: () => z
        .string()
        .trim()
        .max(LIMITS.note.maxLength, `${LIMITS.note.label} must be ${LIMITS.note.maxLength} characters or fewer.`)
        .nullish()
        .transform((value) => (value == null || value === '' ? undefined : value))
        .optional(),
    explanation: () => z
        .string()
        .trim()
        .max(LIMITS.explanation.maxLength, `${LIMITS.explanation.label} must be ${LIMITS.explanation.maxLength} characters or fewer.`)
        .nullish()
        .transform((value) => (value == null || value === '' ? undefined : value))
        .optional(),
    lotNumber: () => z
        .string()
        .trim()
        .max(LIMITS.lotNumber.maxLength, `${LIMITS.lotNumber.label} must be ${LIMITS.lotNumber.maxLength} characters or fewer.`)
        .nullish()
        .transform((value) => (value == null || value === '' ? undefined : value))
        .optional(),
};
//# sourceMappingURL=adjust-fields.js.map